type StoredMemberAddress = {
  streetAddress?: string | null;
  city?: string | null;
  province?: string | null;
  postalCode?: string | null;
  country?: string | null;
} | null | undefined;

export type MemberFormAddress = {
  streetAddress: string;
  city: string;
  provinceOrState: string;
  postalOrZipCode: string;
  country: string;
};

const memberFormAddressKeys = ["streetAddress", "city", "provinceOrState", "postalOrZipCode", "country"] as const;

export const isBlankMemberBillingAddress = (billing: StoredMemberAddress) =>
  ![billing?.streetAddress, billing?.city, billing?.province, billing?.postalCode].some((value) => (value || "").trim());

export const getStoredBillingFormAddress = (billing: StoredMemberAddress): MemberFormAddress => ({
  streetAddress: billing?.streetAddress || "",
  city: billing?.city || "",
  provinceOrState: billing?.province || "",
  postalOrZipCode: billing?.postalCode || "",
  country: billing?.country || "Canada",
});

const pickMemberFormAddress = (address: MemberFormAddress): MemberFormAddress =>
  Object.fromEntries(memberFormAddressKeys.map((key) => [key, address[key]])) as MemberFormAddress;

/**
 * Monday 13397260528 (S16), Moeen Q15 Oct 28 2026: a member with no billing
 * address is billed at the company address (backend
 * resolveCmpMemberBillingAddress), so Update Member shows the company address
 * there and "Check here if same as Member Company Address" is ticked.
 */
export const getMemberBillingFormAddress = ({
  billing,
  company,
}: {
  billing: StoredMemberAddress;
  company: MemberFormAddress;
}): MemberFormAddress =>
  isBlankMemberBillingAddress(billing) ? pickMemberFormAddress(company) : getStoredBillingFormAddress(billing);

/**
 * True while the form still shows the company address for a blank stored
 * billing address. The save then keeps the stored blank, so nothing is saved
 * until staff change the billing fields and invoices keep following the
 * company address.
 */
export const keepsStoredBlankBillingAddress = ({
  billing,
  company,
  form,
}: {
  billing: StoredMemberAddress;
  company: MemberFormAddress;
  form: MemberFormAddress;
}) =>
  isBlankMemberBillingAddress(billing) &&
  memberFormAddressKeys.every((key) => form[key] === company[key]);
